import { cn } from "../utils/helpers";
import { SvgProps } from "../utils/types";

export default function ArrowDownLeftIcon({ className }: SvgProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={cn("size-3.5 shrink-0", className)}
        >
            <line x1="17" y1="7" x2="7" y2="17" />
            <polyline points="17 17 7 17 7 7" />
        </svg>
    );
}
